__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "Leap360-Container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(407)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(114), __webpack_require__.e(407), __webpack_require__.e(998), __webpack_require__.e(727)]).then(() => (() => (__webpack_require__(3727))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(114), __webpack_require__.e(550), __webpack_require__.e(407)]).then(() => (() => (__webpack_require__(6550))))));
			register("react", "17.0.2", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			initExternal(7384);
			initExternal(1501);
			initExternal(639);
			initExternal(1204);
			initExternal(2091);
			initExternal(662);
			initExternal(5864);
			initExternal(8380);
			initExternal(4411);
			initExternal(5281);
			initExternal(3276);
			initExternal(6724);
			initExternal(5997);
			initExternal(3729);
			initExternal(7367);
			initExternal(5990);
			initExternal(7205);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};